const pageDefaultHeight = '1054px';
const pageDefaultWidth = '816px';

export { pageDefaultHeight, pageDefaultWidth };
